import { CreditCheckScreeningRequestBody, CreditCheckScreeningResponseBody } from '@boltenergy-be/shared'
import { NextApiResponseBody } from 'types/bolt-api/request'

export const postCreditCheckScreening = async (
  opportunityId: string,
  body: CreditCheckScreeningRequestBody
): Promise<NextApiResponseBody<CreditCheckScreeningResponseBody>> => {
  try {
    const res = await fetch(`/api/prospects/${opportunityId}/credit-check-screening`, {
      method: 'POST',
      body: JSON.stringify(body)
    })

    return (await res.json()) as NextApiResponseBody<CreditCheckScreeningResponseBody>
  } catch (error) {
    return { success: false }
  }
}
